import { useQuery } from '@tanstack/react-query';
import { APITypes } from '../../primary-record-types';
import { getIntl } from '../../utils/intl';
import urls from '../../utils/urls';
import { appAPI } from '../../utils/api';
import { getMyInvitesCacheKey } from './cacheKeys';
import { useQueryErrorNotify } from '../useQueryCallbacks';

const intl = getIntl('useCollaboratorInvitations', {
    invitationsLoadError: 'Error loading invitations',
});

export type UseCollaboratorInvitationsArgs = {};

export type UseCollaboratorInvitationsReturnValue = {
    invitations: APITypes.medicalProfileService.CollaboratorInviteListItem[];
    isLoadingInvitations: boolean;
};

export const useCollaboratorInvitations = (
    _args: UseCollaboratorInvitationsArgs,
): UseCollaboratorInvitationsReturnValue => {
    const invitationsQuery = useQuery({
        queryKey: getMyInvitesCacheKey(),
        queryFn: async () => {
            const response = (await appAPI.get(
                urls.api.collaborators.myInvites,
            )) as APITypes.medicalProfileService.ListCollaboratorInvitesResponse;
            return response.invites;
        },
        refetchInterval: 1000 * 60, // 1 minute
    });
    useQueryErrorNotify(invitationsQuery, intl('invitationsLoadError'));

    return {
        invitations: invitationsQuery.data || [],
        isLoadingInvitations: invitationsQuery.isLoading,
    };
};
